import Popup from "reactjs-popup";
import * as React from "react";
import "./ToolTip.scss";
import { PopupPosition } from "reactjs-popup/dist/types";

export interface ToolTipProps {
    text: string;
    iconSize?: number;
    dataTestIdTrigger?: string;
    dataTestIdContent?: string;
    position?: PopupPosition | PopupPosition[];
}

const ToolTip = (props: ToolTipProps) => {
    const iconSize = props.iconSize ? props.iconSize : 24;

    return (
        <span className={"eos-tooltip"}>
            <Popup
                position={props.position}
                trigger={() => <i className="icon-info tool-tip-icon" data-test={props.dataTestIdTrigger} style={{ fontSize: iconSize }}></i>}
                closeOnDocumentClick>
                <div className="modal" data-test={props.dataTestIdContent}>
                    {props.text}
                </div>
            </Popup>
        </span>
    );
};

export default ToolTip;
